<template>
  <div class="anchor-container">
    <!--左边滚动锚点-->
    <div class="anchor-container-left" :style="leftStyles">
      <div 
        @click="handTabs(item.value)"
        v-for="(item, index) in tabs" 
        :key="index" 
        class="anchor-container-left_label"
        :class="[currentIndex === index && 'is-label-active', currentIndex > index && 'is-finish-active']">
        <span class="label-number">
          <template v-if="!item.status || item.status === 'waiting'">
            {{index + 1}}
          </template>
          <template v-else-if="item.status === 'finish'">
            <i class="el-icon-check"></i>
          </template>
        </span>
        <span class="label-text">{{item.name}}</span>
      </div>
    </div>
    <!--右边容器-->
    <div class="anchor-container-right" >
      <div class="container-right-main" ref="contanier">
        <slot></slot>
      </div>
      <div class="fotter-btn" v-if="$slots.fotter">
        <slot name="fotter"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "anchor-container",
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    leftWidth: {
      type: String,
      default: '148px'
    },
    offsetTop: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tabs: [],
      currentValue: this.value,
      isreturn: false,
      // tabs: [],
      currentIndex: 0
    };
  },
  watch: {
    currentValue(vals) {
      this.currentIndex = this.tabs.findIndex(v => v.value === vals) 
      this.currentIndex = this.currentIndex >= 0 ? this.currentIndex : 0
      this.$emit('input', vals)
    },
    value(val) {
      // this.currentValue = val
      // const instance = this.tabs.find(v => v.value === val)
      // this.currentValue = instance.value
      // this.smoothScroll(instance.$el)
    }
  },
  mounted() {
    this.bindEvent()
  },
  beforeDestroy() {},
  computed: {
    leftStyles() {
      return {
        flexBasis: this.leftWidth,
        width: this.leftWidth
      }
    },
  },
  methods: {
    // 初始化
    init() {
      this.currentValue = this.value || this.tabs[0].value || ''
    },

    bindEvent() {
      this.$refs.contanier.addEventListener('scroll', this.debounce({
        callback: this.scrollCallback,
        seconds: 300
      }))
    },

    scrollCallback() {
      if (this.isreturn) {
        this.isreturn = false
        return
      }
      const contaniner = this.$refs.contanier
      // 如果滚动到底部，取最后一项
      if( contaniner.scrollHeight - contaniner.scrollTop === contaniner.clientHeight) {
        const len = this.tabs.length
        this.currentValue = this.tabs[len - 1].value
      } else {
        // 先拿到所有项的value形成队列，在过滤掉不在可见范围内的value
        let activeVals = this.tabs.map(v => v.scroll(contaniner)).filter(v => v)
        this.updateActive(activeVals)
      }
    } ,
    // 更新当前滚动哪个子节点下
    updateActive(arr) {
      this.currentValue = arr[0]
    },
    // 选中锚点
    handTabs(val) {
      this.isreturn = true
      const instance = this.tabs.find(v => v.value === val)
      this.currentValue = instance.value
      this.smoothScroll(instance.$el)
      
    },
    // 滚动到指定位置
    smoothScroll (element) {
       element.scrollIntoView({behavior: 'smooth'})
    },
    createEl(instance) {
      this.tabs.push(instance)
      this.$nextTick(_ => {
        this.init()
      })
    },
    remove(instance) {
      const index = this.tabs.findIndex(v => v.value === instance.value)
      if (index >= 0) {
        this.tabs.splice(index, 1)
        this.scrollCallback()
      }
    },
    // 外界有数据变化时，调用该方法重新赋值
    updateData(instance) {
      let index = this.tabs.findIndex(v => v.value === instance.value)
      index = index >=0 ? index : 0
      this.tabs[index].name = instance.name
      this.tabs[index].value = instance.value
      this.tabs[index].status = instance.status || 'waiting'
    },
    // 防抖
    debounce({callback = null, reset = null, seconds = 100}) {
      let timer = null
      return e => {
        if (timer) {
          clearTimeout(timer)
          reset && typeof reset === 'function' && reset.call(this, e)
        }
        timer && clearTimeout(timer)
        timer = setTimeout(_ => {
          callback.call(this, e)
          timer = null
        }, seconds)
      }
    },

    // 跳转到指定目录
    goStep(value) {
      this.handTabs(value)
    }
  }
};
</script>

<style scoped lang="scss">
$active-color: #1F6EEF;
$basic-color: #666;

@mixin setbg-color() {
  &.anchor-container-left_label {
    &::before {
      background: $active-color;
    }
  }
}
.anchor-container {
  height: 100%;
  display: flex;
  overflow: hidden;
  .anchor-container-left {
    background-color: #fff;
    border-radius: 4px;
    padding: 20px 15px;
    box-sizing: border-box;
    height: 100%;
    overflow-y: auto;
    .anchor-container-left_label {
      font-size: 14px;
      color: $basic-color;
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: all .35s;
      font-weight: 500;
      &:not(.is-label-active):hover {
        opacity: .8;
      }
      &.is-label-active {
        color: $active-color;
        .label-number {
          background-color: $active-color;
          color: #Fff;
          border-color: transparent;
        }
        @include setbg-color();
      }
      &.is-finish-active {
        .label-number {
          border-color: $active-color;
          color: $active-color;
        }
        @include setbg-color();
        // &.anchor-container-left_label {
        //   &::before {
        //     background: $active-color;
        //   }
        // }
      }
      .label-text {
        flex: 1;
        overflow: hidden;
        white-space:nowrap
      }
      .label-number {
        width: 18px;
        height: 18px;
        border-radius: 100%;
        border: 1px solid #E4E5E6;
        text-align: center;
        line-height: 18px;
        margin-right: 10px;
        transition: all .35s;
        font-size: 12px;
        color: $basic-color;
      }
    }
    .anchor-container-left_label + .anchor-container-left_label {
      margin-top: 40px;
      position: relative;
      &::before {
        content: '';
        position: absolute;
        display: block;
        top: -35px;
        bottom: 0;
        width: 1px;
        height: 30px;
        left: 10px;
        background-color:#E4E5E6;
      }
    }
  }

  .anchor-container-right {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-left: 10px;
    height: 100%;
    background-color: #fff;
    border-radius: 4px;
    flex: 1;
    overflow: hidden;
    .container-right-main {
      padding: 16px;
      box-sizing: border-box;
      overflow-y: auto;
      flex: 1;
    }
    .fotter-btn {
      background-color: #fff;
      z-index: 1;
      box-shadow: 0px -2px 4px 0px rgba(0,0,0,0.1);
      padding: 12px 0;
    }
  }
}
</style>